import React, { useId, useMemo } from "react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import { Label } from "@/components/ui/label";

interface AmenityCategoryFieldProps {
  label: string;
  placeholder: string;
  value: string;
  options: string[];
  onChange: (value: string) => void;
  error?: string;
  helperText?: string;
  className?: string;
}

const AmenityCategoryField: React.FC<AmenityCategoryFieldProps> = ({
  label,
  placeholder,
  value,
  options,
  onChange,
  error,
  helperText,
  className,
}) => {
  const listId = useId();
  const inputId = `${listId}-input`;
  const normalizedOptions = useMemo(
    () =>
      Array.from(
        new Set(options.map((option) => option.trim()).filter(Boolean)),
      ),
    [options],
  );

  return (
    <div className={cn("space-y-2", className)}>
      <Label htmlFor={inputId}>{label}</Label>
      <Input
        id={inputId}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        list={listId}
        aria-invalid={!!error}
      />
      <datalist id={listId}>
        {normalizedOptions.map((option) => (
          <option key={option} value={option} />
        ))}
      </datalist>
      {helperText ? (
        <p className="text-sm text-black/45">{helperText}</p>
      ) : null}
      {error ? <p className="text-destructive text-sm">{error}</p> : null}
    </div>
  );
};

export default AmenityCategoryField;
